import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const DELETE_WORKSPACE_PREBID_MODULE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation deleteWorkspacePrebidModule($input: DeleteWorkspacePrebidModuleInput!) {
    deleteWorkspacePrebidModule(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
